<div class="modal-header py-1">
  <h5 class="modal-title" id="modal-basic-title">{{ title }}</h5>
  <button class="btn btn-close-white" (click)="close()">
    <i class="bi bi-x-circle-fill"></i>
  </button>
</div>
<div class="modal-body overflow-auto">
  <ng-content select="[modalBody]"></ng-content>
</div>
<div class="modal-footer d-flex justify-content-end">
  <ng-content select="[modalFooter]"></ng-content>
</div>
